import type {UpholsteryWriteRequestBody} from '@dms/api/new-vehicle';

import type {PricedItemBatchEntry} from '../types/PricedItemBatchEntry';
import {createdItem} from './createdItem';
import {pricedItemGroupKeys} from './pricedItemGroupKeys';

/**
 * The row of an upholstery create and its entry for an open group. The entry sends the create body
 * as the form made it, with its client id; nothing in the batch names the new upholstery.
 */
export const upholsteryCreateChange = (body: UpholsteryWriteRequestBody) => {
  const items = [createdItem('upholstery', 'new-upholstery', body.name, body.priceNet)];
  const grouped = pricedItemGroupKeys.newCreate('upholstery');
  return {
    items,
    entry: {
      ...grouped,
      title: body.name,
      usedValues: pricedItemGroupKeys.usedValue('upholstery', 'name', body.name),
      build: () =>
        Promise.resolve({
          items,
          operations: [{type: 'upholstery.create' as const, id: grouped.createdId, body}],
        }),
    } satisfies Omit<PricedItemBatchEntry, 'items'>,
  };
};
